
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcElevatedCardRadioGroup as ObcElevatedCardRadioGroupElement} from '@oicl/openbridge-webcomponents/dist/components/elevated-card-radio-group/elevated-card-radio-group.js';
 import {ObcElevatedCardRadioGroupChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/elevated-card-radio-group/elevated-card-radio-group.js';
 export type {ObcElevatedCardRadioGroupChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/elevated-card-radio-group/elevated-card-radio-group.js';
 

 
 export const ObcElevatedCardRadioGroup = createComponent({
   react: React,
   tagName: 'obc-elevated-card-radio-group',
   elementClass: ObcElevatedCardRadioGroupElement,
   events: {
     
     onChange: 'change' as EventName<ObcElevatedCardRadioGroupChangeEvent>,
   }
  });
 
 